'use client';

import { UIComponent } from '@/components/core/components';
import Ads from '@/components/core/components/molecules/ads';
import clsx from 'clsx';
import { Image } from '@/components/core/components/atoms';
import { Trans } from '@lingui/react/macro';
import { useState } from 'react';
import * as styles from './feed-ads.styles';
import FeedBackground from '../feed-background';

const FeedAds: UIComponent = ({ className, ...props }) => {
  const [options, setOptions] = useState<{
    showDefault?: boolean;
    background?: string;
    isVideo?: boolean;
  }>({});
  return (
    <FeedBackground
      className={clsx(styles.feed, className, {
        [styles.video]: options.isVideo,
      })}
      {...props}
    >
      <div className={styles.header}>
        <Image src="/logo-square.png" alt="logo" className={clsx(styles.logo)} />
        <span className={styles.title}>Peoople</span>
        <span className={styles.subtitle}>
          <Trans>Sponsored</Trans>
        </span>
      </div>
      <Ads
        size={[300, 250]}
        className={clsx(styles.ads)}
        onStatusChange={(evt) => {
          setOptions({
            showDefault: evt.status === 'empty',
          });
        }}
      />
    </FeedBackground>
  );
};

export default FeedAds;
